export const MAIN_CONTAINER = "bg-white ";
export const INNER_CONTAINER_ONE = " py-5 md:py-10  ";

export const TEXT_INNER_CONTAINER_ONE =
    "flex justify-center max-w-[95%] mx-auto pb-5";
